import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ProvideAuth } from "@warden-ui/common";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme";

import "@warden-ui/i18n";
import "./styles.scss";
import * as Page from "./pages";
import { initializeLogger } from "@warden-ui/common";
import { CupixThemeContext } from "@warden-ui/common-components";
initializeLogger();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Page.Signin />,
  },
  {
    path: '/signin/password',
    element: <Page.SigninPassword />,
  },
  {
    path: '/signin/mfa',
    element: <Page.SigninMfa />,
  },
  {
    path: '/reset_password/request',
    element: <Page.ResetPasswordRequest />,
  },
  {
    path: '/reset_password/code',
    element: <Page.ResetPasswordCode />,
  },
  {
    path: '/reset_password/submit',
    element: <Page.ResetPasswordSubmit />,
  },
  {
    path: "/redirect",
    element: <Page.RedirectToRedirectUri />,
  },
  {
    path: "/signout",
    element: <Page.Signout />,
  }
]);

root.render(
  <React.StrictMode>
    <CupixThemeContext.Provider value="cupix">
      <ThemeProvider theme={theme}>
        <ProvideAuth>
          <RouterProvider router={router} />
        </ProvideAuth>
      </ThemeProvider>
    </CupixThemeContext.Provider>
  </React.StrictMode>
);